@if (spinnerService.isLoading()) {
  <app-spinner></app-spinner>
}

<router-outlet />
